import { render, staticRenderFns } from "./quesInstru9.vue?vue&type=template&id=46098e6c"
import script from "./quesInstru9.vue?vue&type=script&lang=js"
export * from "./quesInstru9.vue?vue&type=script&lang=js"
import style0 from "./quesInstru9.vue?vue&type=style&index=0&id=46098e6c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports